import { createAction } from '@reduxjs/toolkit';

import {
  ArticleFeedbackEvent,
  ArticleTicketAssistEvent,
} from '../analytics/events';
import {
  FeedbackChangedPayload,
  HaveFeedbackPressedPayload,
} from '../types/elevio.actions';

const prefix = `elevio/feedback`;

export const feedbackActions = {
  // Feedback
  ticketAssisted: createAction<ArticleTicketAssistEvent>(
    `${prefix}/ticketAssisted`,
  ),
  haveFeedbackPressed: createAction<HaveFeedbackPressedPayload>(
    `${prefix}/haveFeedbackPressed`,
  ),
  feedbackSubmit: createAction<ArticleFeedbackEvent>(
    `${prefix}/feedbackSubmit`,
  ),
  feedbackReset: createAction(`${prefix}/feedbackReset`),
  feedbackChanged: createAction<FeedbackChangedPayload>(
    `${prefix}/feedbackChanged`,
  ),
};
